/* Cloudy Cotton — theme behaviour
   Everything here exists to shorten the path from tap to order:
   drawers, one-tap add, live cart, variant switching, predictive search. */

(function () {
  'use strict';

  var routes = window.CC_ROUTES || {};
  var closeModal = function () {};
  var cartBusy = false;
  function jsonResponse(r) { return r.json().then(function (data) { if (!r.ok) throw new Error(data.description || data.message || strings.cart_error || 'Please try again.'); return data; }); }
  var strings = window.CC_STRINGS || {};

  /* ---------------- Drawers ---------------- */

  var lastFocus = null;

  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    el.inert = false;
    document.querySelectorAll('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    document.body.style.overflow = 'hidden';
    var focusable = el.querySelector('[autofocus], button, a[href], input, select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 120);
  }

  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    el.inert = true;
    document.querySelectorAll('[data-drawer-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!document.querySelector('.drawer.is-open')) document.body.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }

    var closer = e.target.closest('[data-drawer-close]');
    if (closer) { if (closer.tagName !== 'A') e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.drawer.is-open');
    if (open) closeDrawer(open);
  });

  /* Keep focus inside an open drawer */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var drawer = document.querySelector('.drawer.is-open');
    if (!drawer) return;
    var items = drawer.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!items.length) return;
    items = Array.prototype.filter.call(items, function (el) { return el.getClientRects().length > 0; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- Toast ---------------- */

  var toastEl;
  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* ---------------- Cart ---------------- */

  function refreshCart(openAfter) {
    return fetch((routes.root || '/') + '?sections=cart-drawer')
      .then(jsonResponse)
      .then(function (data) {
        if (!data['cart-drawer']) throw new Error('Cart updated. Please open your cart to continue.');
        var parsed = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
        var fresh = parsed.getElementById('CartDrawerContents');
        var current = document.getElementById('CartDrawerContents');
        var note = current && current.querySelector('[name="note"]');
        var savedNote = note && note.value;
        if (fresh && current) current.replaceWith(fresh);
        if (savedNote != null && fresh) { var newNote = fresh.querySelector('[name="note"]'); if (newNote) newNote.value = savedNote; }
        if (!fresh) throw new Error('Please open your cart to continue.');
        var count = Number(fresh.dataset.itemCount || 0);
        document.querySelectorAll('[data-cart-count]').forEach(function (node) { node.textContent = count; node.hidden = count === 0; });
        if (openAfter) {
          if ((window.CC_SETTINGS || {}).cart_type === 'page') window.location.href = routes.cart || '/cart';
          else openDrawer('CartDrawer');
        }
      });
  }

  function addToCart(form, button) {
    if (cartBusy || (button && (button.disabled || button.getAttribute('aria-disabled') === 'true')) || !form.reportValidity()) return;
    cartBusy = true;
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    if (button) { button.classList.add('loading'); button.disabled = true; button.setAttribute('aria-disabled', 'true'); }

    return fetch(routes.cart_add || '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.json.description || res.json.message || strings.cart_error || 'Could not add that.');
          return;
        }
        closeModal();
        return refreshCart(true);
      })
      .catch(function (err) { toast(err.message || strings.cart_error || 'Something went wrong. Try again.'); })
      .finally(function () {
        cartBusy = false;
        if (button) { button.classList.remove('loading'); button.disabled = false; button.removeAttribute('aria-disabled'); }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (form && form.classList.contains('installment')) return;
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[data-add-button]'));
  });

  /* Quick add straight from a product card */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (cartBusy || btn.disabled) return;
    cartBusy = true; btn.disabled = true;
    var id = btn.getAttribute('data-quick-add');
    btn.classList.add('loading');
    fetch(routes.cart_add || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        if (json.status) { toast(json.description || json.message); return; }
        return refreshCart(true);
      })
      .catch(function (err) { toast(err.message || strings.cart_error || 'Something went wrong. Try again.'); })
      .finally(function () { btn.classList.remove('loading'); btn.disabled = false; cartBusy = false; });
  });

  /* Line quantity changes */
  function changeLine(line, quantity) {
    if (cartBusy || !Number.isInteger(Number(quantity)) || Number(quantity) < 0) return;
    cartBusy = true;
    var container = document.getElementById('CartDrawerContents');
    if (container) container.classList.add('loading');
    document.querySelectorAll('[data-line-qty], [data-line-remove], .cart-line [data-qty-step]').forEach(function (el) { el.disabled = true; });
    fetch(routes.cart_change || '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    }).then(jsonResponse).then(function () {
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshCart(false);
    }).catch(function (err) { toast(err.message || strings.cart_error); return refreshCart(false).catch(function () {}); })
      .finally(function () {
        cartBusy = false;
        var current = document.getElementById('CartDrawerContents'); if (current) current.classList.remove('loading');
        document.querySelectorAll('[data-line-qty], [data-line-remove], .cart-line [data-qty-step]').forEach(function (el) { el.disabled = false; });
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-line-remove]');
    if (remove) { e.preventDefault(); changeLine(remove.getAttribute('data-line-remove'), 0); return; }

    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var wrap = step.closest('.qty');
    var input = wrap.querySelector('input');
    if (!input || step.disabled) return;
    var next = Math.max(Number(input.min || 1), Number(input.value) + Number(step.getAttribute('data-qty-step')));
    if (input.max) next = Math.min(Number(input.max), next);
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-line-qty]');
    if (!input) return;
    changeLine(input.getAttribute('data-line-qty'), input.value);
  });

  /* ---------------- Product variants ---------------- */

  function initProductForm(root) {
    if (root.dataset.initialized === 'true') return;
    var dataEl = root.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    root.dataset.initialized = 'true';
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price-target]');
    var addBtn = root.querySelector('[data-add-button]');
    var handle = root.getAttribute('data-product-url');

    function currentOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function match(selected) {
      return variants.find(function (v) {
        return selected.every(function (value, i) { return value === null || v.options[i] === value; });
      });
    }

    function markUnavailable(selected) {
      root.querySelectorAll('[data-option-index]').forEach(function (group, index) {
        group.querySelectorAll('input').forEach(function (input) {
          var probe = selected.slice();
          probe[index] = input.value;
          var candidate = variants.find(function (v) {
            return probe.every(function (value, i) { return value === null || v.options[i] === value; });
          });
          var label = group.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !candidate || !candidate.available);
        });
      });
    }

    function syncLabels() {
      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var out = group.querySelector('[data-option-current]');
        if (checked && out) {
          var label = group.querySelector('label[for="' + checked.id + '"]');
          out.textContent = label ? label.textContent.trim() : checked.value;
        }
      });
    }

    function syncSticky(variant) {
      if (!root.classList.contains('pdp')) return;
      var stickyButton = document.querySelector('[data-sticky-submit]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyButton) { stickyButton.disabled = !variant || !variant.available; stickyButton.textContent = !variant ? (strings.unavailable || 'Unavailable') : variant.available ? (strings.add_to_cart || 'Add to cart') : (strings.sold_out || 'Sold out'); }
      if (stickyPrice) stickyPrice.textContent = variant ? variant.price_text : '';
    }

    function update() {
      var selected = currentOptions();
      syncLabels();
      var variant = match(selected);
      markUnavailable(selected);

      if (!variant) {
        if (idInput) { idInput.value = ''; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        root.querySelectorAll('.buy-actions').forEach(function (el) { el.hidden = true; });
        if (addBtn) { addBtn.disabled = true; addBtn.setAttribute('aria-disabled', 'true'); addBtn.textContent = strings.unavailable || 'Unavailable'; }
        syncSticky(null);
        return;
      }

      if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      root.querySelectorAll('.buy-actions').forEach(function (el) { el.hidden = !variant.available; });
      var sku = root.querySelector('[data-sku]'), skuWrap = root.querySelector('[data-sku-wrap]');
      if (sku) sku.textContent = variant.sku || '';
      if (skuWrap) skuWrap.hidden = !variant.sku;
      if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;

      if (addBtn) {
        if (variant.available) {
          addBtn.disabled = false;
          addBtn.removeAttribute('aria-disabled');
          addBtn.textContent = strings.add_to_cart || 'Add to cart';
        } else {
          addBtn.disabled = true;
          addBtn.setAttribute('aria-disabled', 'true');
          addBtn.textContent = strings.sold_out || 'Sold out';
        }
      }

      root.querySelectorAll('form.installment [name="id"]').forEach(function (i) { i.value = variant.id; });
      syncSticky(variant);
      var qaImage = root.querySelector('.qa__media img');
      if (qaImage && variant.image) {
        qaImage.srcset = '';
        qaImage.src = variant.image;
      }

      if (variant.image_index != null) {
        var media = root.closest('.pdp') || root;
        var target = media.querySelector('[data-media-index="' + variant.image_index + '"]');
        if (target) {
          if (target.hasAttribute('hidden') || target.closest('.gallery--thumbs')) {
            showGalleryIndex(media, variant.image_index);
          } else if (target.scrollIntoView) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }
      }

      var pickup = root.querySelector('[data-pickup]');
      if (pickup && handle) {
        pickup.setAttribute('data-url', handle + '?variant=' + variant.id + '&section_id=pickup-availability');
        refreshPickup(pickup);
      }

      if (handle && root.classList.contains('pdp') && document.body.classList.contains('template-product') && window.history.replaceState) {
        var pageUrl = new URL(window.location.href); pageUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', pageUrl.toString());
      }
    }

    root.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-index]')) update();
    });

    update();
  }

  function showGalleryIndex(scope, index) {
    scope.querySelectorAll('.gallery--thumbs [data-media-index]').forEach(function (item) {
      item.hidden = Number(item.getAttribute('data-media-index')) !== Number(index);
    });
    scope.querySelectorAll('[data-thumb]').forEach(function (btn) {
      if (Number(btn.getAttribute('data-thumb')) === Number(index)) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    showGalleryIndex(thumb.closest('.pdp') || document, thumb.getAttribute('data-thumb'));
  });

  document.querySelectorAll('[data-product-form]').forEach(initProductForm);

  /* ---------------- Share ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-share]');
    if (!btn) return;
    var url = btn.getAttribute('data-share');
    if (navigator.share) { navigator.share({ url: url }).catch(function () {}); return; }
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(function () { toast(strings.link_copied || 'Link copied'); });
    }
  });

  /* ---------------- Quick add popup ---------------- */

  var modal = document.getElementById('QuickAddModal');
  var modalBody = modal && modal.querySelector('[data-modal-body]');
  var modalOpener = null;
  var modalCache = {};

  function openModal() {
    if (!modal) return;
    modal.inert = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  closeModal = function () {
    if (!modal || !modal.classList.contains('is-open')) return;
    modal.inert = true;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) document.body.style.overflow = '';
    if (modalOpener) { modalOpener.focus(); modalOpener = null; }
  };

  function fillModal(html) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var content = parsed.querySelector('.qa');
    if (!content) return false;
    modalBody.innerHTML = '';
    modalBody.appendChild(content);
    initProductForm(content);
    var focusable = content.querySelector('input, button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 140);
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-modal]');
    if (!btn || !modal) return;
    e.preventDefault();

    var url = btn.getAttribute('data-quick-modal');
    modalOpener = btn;
    btn.classList.add('loading');

    if (modalCache[url]) {
      fillModal(modalCache[url]);
      btn.classList.remove('loading');
      openModal();
      return;
    }

    modalBody.innerHTML = '<div class="modal__loading">' + (strings.loading || 'Loading') + '</div>';
    openModal();

    var sep = url.indexOf('?') === -1 ? '?' : '&';
    fetch(url + sep + 'section_id=quick-add')
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.text();
      })
      .then(function (html) {
        modalCache[url] = html;
        if (!fillModal(html)) { window.location.href = url; }
      })
      .catch(function () {
        // if anything goes wrong, fall back to the product page rather than trapping the customer
        window.location.href = url;
      })
      .finally(function () { btn.classList.remove('loading'); });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-modal-close]')) { e.preventDefault(); closeModal(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* Keep focus inside the popup */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !modal || !modal.classList.contains('is-open')) return;
    var items = modal.querySelectorAll('a[href], button:not([disabled]), input, select, textarea');
    if (!items.length) return;
    items = Array.prototype.filter.call(items, function (el) { return el.getClientRects().length > 0; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------------- Subscriptions ---------------- */

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-selling-plan-input]');
    if (!input) return;
    var root = input.closest('[data-product-form]') || document;
    var field = root.querySelector('[data-selling-plan-field]');
    if (field) field.value = input.value;
  });

  /* ---------------- Gift card recipient ---------------- */

  document.addEventListener('change', function (e) {
    var toggle = e.target.closest('[data-recipient-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('.recipient');
    var fields = wrap && wrap.querySelector('[data-recipient-fields]');
    if (fields) { fields.hidden = !toggle.checked; fields.querySelectorAll('input,textarea').forEach(function (el) { el.disabled = !toggle.checked; }); var email = fields.querySelector('[type=email]'); if (email) email.required = toggle.checked; }
    var offset = wrap && wrap.querySelector('[data-recipient-offset]');
    if (offset) offset.value = new Date().getTimezoneOffset();
  });

  /* ---------------- Pickup availability ---------------- */

  function refreshPickup(root) {
    var url = root.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pickup-result]');
        var current = root.querySelector('[data-pickup-result]');
        if (!fresh) return;
        if (current) current.replaceWith(fresh);
        else root.appendChild(fresh);
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-pickup]').forEach(refreshPickup);

  /* ---------------- Carousels ---------------- */

  document.querySelectorAll('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('.carousel__track');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    sync();
  });

  /* ---------------- Slideshow ---------------- */

  document.querySelectorAll('[data-slideshow]').forEach(function (root) {
    var track = root.querySelector('.slideshow__track');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-slide-to]'));
    if (!track) return;
    var slides = track.children.length;
    var index = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function go(i, smooth) {
      index = (i + slides) % slides;
      track.scrollTo({ left: track.clientWidth * index, behavior: smooth === false ? 'auto' : 'smooth' });
      dots.forEach(function (d, di) {
        if (di === index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { go(Number(dot.getAttribute('data-slide-to'))); });
    });

    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) go(i, false);
    }, { passive: true });

    if (root.dataset.autoplay === 'true' && slides > 1 && !reduced) {
      var ms = (Number(root.dataset.speed) || 6) * 1000;
      var timer = setInterval(function () { go(index + 1); }, ms);
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
    }
  });

  /* ---------------- Announcement rotation ---------------- */

  document.querySelectorAll('[data-announcement]').forEach(function (root) {
    var msgs = Array.prototype.slice.call(root.querySelectorAll('.announcement__msg'));
    if (msgs.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () {
      msgs[i].hidden = true;
      i = (i + 1) % msgs.length;
      msgs[i].hidden = false;
    }, (Number(root.dataset.speed) || 5) * 1000);
  });

  /* ---------------- Sticky header shrink ---------------- */

  var headerGroup = document.querySelector('[data-header-group]');
  if (headerGroup) {
    var onScroll = function () {
      headerGroup.classList.toggle('is-scrolled', window.scrollY > 40);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Deferred video ---------------- */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-play]');
    if (!btn) return;
    var wrap = btn.closest('[data-video]');
    var tpl = wrap && wrap.querySelector('[data-video-embed]');
    if (!tpl) return;
    wrap.innerHTML = tpl.innerHTML;
  });

  /* ---------------- Sticky mobile buy bar ---------------- */

  var sticky = document.querySelector('.sticky-buy');
  var anchor = document.querySelector('#ProductForm');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-buy');
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  }

  /* ---------------- Predictive search ---------------- */

  var searchInput = document.querySelector('[data-predictive-input]');
  var searchResults = document.querySelector('[data-predictive-results]');
  if (searchInput && searchResults) {
    var timer, searchVersion = 0;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var version = ++searchVersion;
      var term = searchInput.value.trim();
      if (term.length < 2) { searchResults.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch((routes.predictive_search || '/search/suggest') + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=6&section_id=predictive-search')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('[data-predictive-results]');
            if (fresh && version === searchVersion) searchResults.innerHTML = fresh.innerHTML;
          }).catch(function () { if (version === searchVersion) searchResults.innerHTML = '<p>Use the search button to see results.</p>'; });
      }, 220);
    });
  }

  /* ---------------- Facets: submit on change ---------------- */

  document.querySelectorAll('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function (e) { if (e.target.name === 'sort_by') form.requestSubmit(); });
  });

  document.querySelectorAll('.drawer, .modal').forEach(function (el) { el.inert = !el.classList.contains('is-open'); });
  document.querySelectorAll('[data-drawer-open]').forEach(function (el) { el.setAttribute('aria-controls', el.dataset.drawerOpen); el.setAttribute('aria-expanded', 'false'); });
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-sticky-submit]');
    if (!button || button.disabled) return;
    var form = document.getElementById('ProductForm');
    var submit = form && form.querySelector('[data-add-button]');
    if (form && submit && !submit.disabled) form.requestSubmit(submit);
  });
  document.querySelectorAll('[data-recipient-fields]').forEach(function (fields) { fields.querySelectorAll('input,textarea').forEach(function (el) { el.disabled = fields.hidden; }); });
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-product-form]').forEach(initProductForm); });

  document.querySelectorAll('[data-address-country]').forEach(function (country) {
    var form = country.closest('form'), province = form.querySelector('[data-address-province]'), wrap = form.querySelector('[data-province-wrap]');
    if (country.dataset.default) country.value = country.dataset.default;
    function syncProvince(initial) {
      var option = country.options[country.selectedIndex], provinces = [];
      try { provinces = JSON.parse(option ? option.dataset.provinces || '[]' : '[]'); } catch (err) {}
      province.innerHTML = '';
      provinces.forEach(function (p) { var opt = document.createElement('option'); opt.value = p[0]; opt.textContent = p[1]; province.appendChild(opt); });
      wrap.hidden = provinces.length === 0; province.disabled = provinces.length === 0;
      if (initial && province.dataset.default) province.value = province.dataset.default;
    }
    country.addEventListener('change', function () { syncProvince(false); }); syncProvince(true);
  });
  document.addEventListener('submit', function (e) { if (e.target.matches('[data-address-delete]') && !window.confirm('Delete this address?')) e.preventDefault(); });

  /* ---------------- Reveal on scroll ---------------- */

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'none';
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-reveal]').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(14px)';
      el.style.transition = 'opacity .6s cubic-bezier(.22,.61,.36,1), transform .6s cubic-bezier(.22,.61,.36,1)';
      io.observe(el);
    });
  }
})();
